import React from "react";

const SearchButton = React.forwardRef((props, ref) => {
  const { title, handleClick, disabled = false, height, notAllowed } = props;

  const SearchButtonStyle = {
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    boxShadow: "none",
    fontSize: "12px",
    fontWeight: "bold",
    color: disabled ? "#949494" : "rgb(32, 54, 98)",
    paddingLeft: "0px",
    paddingRight: "0px",
    height: height,
    cursor: notAllowed ? "not-allowed" : disabled ? "default" : "pointer",
    whiteSpace: "nowrap",
  };

  return (
    <button
      style={SearchButtonStyle}
      variant="light"
      disabled={disabled}
      onClick={handleClick}
      height={height}
      ref={ref}
    >
      {title}
    </button>
  );
});

export default SearchButton;
